import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Calendar, CheckCircle } from 'lucide-react';

const ServiceCard = ({ service, isSelected, onToggle, renderPricing, getIcon }) => {
  // Memoize the Link state object to prevent inline object creation
  const linkState = useMemo(() => ({ selectedService: service.name }), [service.name]);

  return (
    <div
      className={`bg-white/5 backdrop-blur-sm border rounded-3xl overflow-hidden transition-all duration-300 ${
        isSelected
          ? 'border-[#B8860B] shadow-xl shadow-[#B8860B]/20'
          : 'border-white/10 hover:border-[#B8860B]/50'
      }`}
      onClick={onToggle}
    >
      <div className="relative h-72 overflow-hidden">
        <img
          src={service.image}
          alt={service.name}
          className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#111216] via-[#111216]/60 to-transparent"></div>
        <div className="absolute top-6 right-6">
          <div className="bg-[#B8860B] text-[#111216] font-bold px-6 py-3 rounded-full text-center">
            <div className="text-sm">Starting at</div>
            <div className="text-lg">${service.startingPrice}</div>
          </div>
        </div>
        <div className="absolute bottom-6 left-6 flex items-center space-x-3">
          <div className="w-14 h-14 rounded-full bg-[#B8860B]/20 backdrop-blur-md flex items-center justify-center text-[#B8860B]">
            {getIcon(service.icon)}
          </div>
          <div>
            <h3 className="text-white font-bold text-2xl">{service.name}</h3>
            <p className="text-gray-300 text-sm">{service.duration}</p>
          </div>
        </div>
      </div>
      
      <div className="p-8">
        <p className="text-gray-300 leading-relaxed mb-6">{service.description}</p>
        
        {/* Pricing Info */}
        {renderPricing(service)}
        
        <div className="space-y-3 mb-6">
          <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-3">
            What&apos;s Included:
          </h4>
          {service.features.map((feature) => (
            <div key={feature} className="flex items-center space-x-3">
              <CheckCircle className="w-5 h-5 text-[#B8860B] flex-shrink-0" />
              <span className="text-gray-300 text-sm">{feature}</span>
            </div>
          ))}
        </div>

        <Link to="/booking" state={linkState}>
          <Button className="w-full bg-gradient-to-r from-[#B8860B] to-[#C8960B] hover:from-[#C8960B] hover:to-[#B8860B] text-[#111216] font-semibold">
            <Calendar className="w-5 h-5 mr-2" />
            Book This Service
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default ServiceCard;
